<div
  class="svg-icon"
  [inlineSVG]="'/assets/icons/accommodation/' + value + '.svg'">
